import type { CategoryCode } from '@/types/domain';

const COLOR: Record<string, string> = {
  strong_match: 'bg-green-100 text-green-800',
  good_match: 'bg-yellow-100 text-yellow-800',
  possible_match: 'bg-orange-100 text-orange-800',
  low_match: 'bg-red-100 text-red-800',
};

const LABEL: Record<string, string> = {
  strong_match: 'Strong',
  good_match: 'Good',
  possible_match: 'Possible',
  low_match: 'Low',
};

interface Props {
  score: number;
  scaleMax: number;
  category: CategoryCode | string | null;
}

export default function ScoreBadge({ score, scaleMax, category }: Props): JSX.Element {
  const key = category || 'unknown';
  const color = COLOR[key] || 'bg-gray-100 text-gray-700';
  const label = LABEL[key] || category || '—';
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs ${color}`}
    >
      <b>{score.toFixed(1)}</b>
      <span className="opacity-70">/ {scaleMax.toFixed(0)}</span>
      <span className="ml-1 opacity-80">{label}</span>
    </span>
  );
}
